<template>
  <el-card shadow="never" :bordered="false">
    <div class="acea-row row-middle">
      <div class="font-sm after-line" @click="goBack">
        <span class="el-icon-arrow-left"></span>
        <span class="pl10">返回</span>
      </div>
      <span class="ht_title ml10">{{ title }}</span>
    </div>
  </el-card>
</template>

<script setup lang="ts">
//4.0
import { useRouter } from 'vue-router';
import { roterPre } from '@/setting';

defineOptions({
  name: 'pagesHeader',
});

const props = withDefaults(
  defineProps<{
    title?: string;
    backUrl?: string;
  }>(),
  {
    title: '',
    backUrl: '',
  },
);

const router = useRouter();

function goBack() {
  if (props.backUrl) {
    router.push({
      path: `${roterPre}${props.backUrl}`,
    });
  } else {
    router.back();
  }
}
</script>

<style scoped>
.after-line {
  display: inline-block;
  position: relative;
  margin-right: 16px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
}
.after-line:after {
  content: '';
  position: absolute;
  top: 3px;
  right: -16px;
  width: 1px;
  height: 16px;
  background: #eee;
}
.font-sm {
  font-size: 14px;
}
.ht_title {
  font-weight: 500;
  font-size: 18px;
}
</style>
